export class ElementsType
{
	/**
	 *
	 */
	public static TRIANGLE:string = "triangle";

	/**
	 *
	 */
	public static LINE:string = "line";
}